import {Component, Object3D, ViewComponent} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';

export class CalculateAspect extends Component {
    static TypeName = 'calculate-aspect';
    private _viewComponent: ViewComponent;

    @property.object({required: true})
    cameraObject!: Object3D;

    start() {
        this._viewComponent = this.cameraObject.getComponent(ViewComponent);
        this.onResize();

        // setTimeout(() => {
        //     this.engine.resize(this.engine.canvas.width, this.engine.canvas.height, 1);
        // }, 3000);
    }

    onActivate(): void {
        this.engine.onResize.add(this.onResize);
    }
    onDeactivate(): void {
        this.engine.onResize.remove(this.onResize);
    }

    calculateHorizontalFOV(verticalFOV: number, aspectRatio: number): number {
        // Convert vertical FOV from degrees to radians
        const verticalFOVRadians = verticalFOV * (Math.PI / 180);

        // Calculate horizontal FOV in radians
        const horizontalFOVRadians =
            2 * Math.atan(Math.tan(verticalFOVRadians / 2) * aspectRatio);

        // Convert horizontal FOV back to degrees
        const horizontalFOV = horizontalFOVRadians * (180 / Math.PI);

        return horizontalFOV;
    }

    onResize = () => {
        const aspect = this.engine.canvas.width / this.engine.canvas.height;
        //const vfov = this.calculateVerticalFov(this.engine.canvas.height, 15);
        const fov = this.calculateHorizontalFOV(60, aspect);
        this._viewComponent.fov = fov; //Math.min(aspect * 90, 90);
    };
}
